import React from 'react';
import { IntegrationsIcon, LightIndicator } from '@commonsku/styles';
import useCompanyGeneralData from './hooks/useCompanyGeneralData';
import { usePromodataStatus } from '../promo-data/hooks';
import { filter, isEmpty, trim } from 'lodash';
import { useHasCapabilities, useHasUserFlag } from '../../hooks';
import { usePoDCredentialStatus } from '../../hooks/usePoDCredentialStatus';

export default function AdminTabbedIntegrationSummary({ title }) {
    const { data: { data } } = useCompanyGeneralData();
    const promodataStatus = usePromodataStatus();
    const hasShipstationCapability = useHasCapabilities(['HAS-SHIPSTATION']);
    const hasPoDEnabled = useHasUserFlag('POD_ENABLED');
    const { credentialStatus } = usePoDCredentialStatus(hasPoDEnabled);

    let accountingSoftware = data?.companyData?.accounting_software;
    const marketing = data?.companyData?.marketing_software;
    const creditCard = data?.companyData?.credit_card_software;
    const sage = data?.sage_account && data?.use_sage_connect == '1';
    const avalara = data?.companyData?.avalara_enable;
    const users = data?.users ?? [];
    const shipstation = data?.companyData?.shipstation_api_v1_enabled === 1;
    if (!accountingSoftware) accountingSoftware = 'CSV';

    const marketingMap = {
        MAILCHIMP: 'Mailchimp',
        WISHPOND: 'Wishpond',
        HUBSPOT: 'HubSpot',
    };

    const accountingMap = {
        QBO: 'Quickbooks Online',
        XERO: 'Xero',
        WEBHOOK: 'Custom Webhook',
        XML: 'XML Export',
        CSV: 'CSV Export',
    };

    const creditcardMap = {
        CARDCONNECT: 'Fiserv',
        STRIPE: 'Stripe',
        COMMONSKU_PAYMENTS: 'commonsku payments'
    };

    // decouples the integration and stored credit card info
    const selectedIntegration = data?.companyData?.commonsku_payments
        ? 'COMMONSKU_PAYMENTS'
        : (creditCard || null);

    const count = filter(users, user => {
        return !isEmpty(trim(user.sage_username));
    }).length;
    return (
        <div style={{ display: 'flex' }}>
            <div><IntegrationsIcon size='large' mr={16} color='#DAE9EE' /></div>
            <div>
                <h5>{title}</h5>
                {useHasCapabilities(['HAS-MARKETING-INTEGRATIONS']) &&
                    <LightIndicator name={<>Marketing Integration{marketing ? <>: {marketingMap[marketing]}</> : ' not configured'}</>} on={marketing ? true : false} />
                }
                <LightIndicator name={<>Credit Card Integration{selectedIntegration ? <>: {creditcardMap[selectedIntegration]}</> : ' not configured'}</>} on={selectedIntegration ? true : false} />
                <LightIndicator name={<>Accounting Integration{accountingSoftware ? <>: {accountingMap[accountingSoftware]}</> : ' not configured'}</>} on={accountingSoftware ? true : false} />
                <LightIndicator name={<>SAGE {sage ? ' configured' : ' not configured'}</>} on={sage ? true : false} />
                <LightIndicator name={<>Credentials entered for {count}/{users.length} users</>} on={count == users.length} />
                <LightIndicator name={<>Promodata Token {promodataStatus === 'ACTIVE' ? ' configured' : promodataStatus === 'EXPIRED' ? ' expired' : ' not configured'}</>} on={promodataStatus === 'ACTIVE' ? true : false} />
                {useHasCapabilities(['HAS-AVALARA']) &&
                    <LightIndicator name={<>Avalara {avalara ? ' configured' : ' not configured'}</>} on={avalara ? true : false} />
                }
                {hasShipstationCapability && <LightIndicator name={<>ShipStation {shipstation ? ' configured' : ' not configured'}</>} on={shipstation ? true : false} />}
                {hasPoDEnabled && <LightIndicator name={<>Print on Demand {credentialStatus.configured ? ' configured' : ' not configured'}</>} on={credentialStatus.configured ? true : false} />}
            </div>
        </div>
    );
}
